import React from "react";

const Details = ({ rowData }) => {
  const fields = [
    { label: "ID", key: "id" },
    { label: "Kiosk ID", key: "kioskId" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "Feature ID", key: "featureId" },
    { label: "Feature Name", key: "featureName" },
    { label: "Duration (Minutes)", key: "durationMinutes" },
    { label: "Created Date", key: "createdDate" },
    { label: "Modified Date", key: "modifiedDate" },
    { label: "Created By", key: "createdBy" },
    { label: "Modified By", key: "modifiedBy" },
    {
      label: "Is Deleted",
      key: "isDeleted",
      format: (val) => (val ? "Yes" : "No"),
    },
  ];

  return (
    <div className="main-form form-details">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key, format }) => (
          <div key={key} className="field col-12 md:col-4 mb-3">
            <label>{label}</label>
            <p>{format ? format(rowData?.[key]) : rowData?.[key] ?? "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
